(function () {
  function avvia(sez) {
    if (sez.dataset.rfPronta) return;
    sez.dataset.rfPronta = '1';

    var pista = sez.querySelector('[data-rf-pista]');
    var box = sez.querySelector('[data-rf-punti]');
    var punti = [];

    function passo() {
      var f = pista.querySelector('.rf-pdp__sl');
      return f ? f.getBoundingClientRect().width + parseFloat(getComputedStyle(pista).columnGap || 12) : 1;
    }

    // un punto per ogni posizione raggiungibile: da desktop si vedono due foto per volta
    function disegnaPunti() {
      if (!pista || !box) return;
      var n = pista.querySelectorAll('.rf-pdp__sl').length;
      var visibili = Math.max(1, Math.round(pista.clientWidth / passo()));
      var quanti = Math.max(0, n - visibili + 1);
      box.innerHTML = '';
      punti = [];
      if (quanti < 2) return;
      for (var i = 0; i < quanti; i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Vai alla posizione ' + (i + 1));
        (function (k) { b.addEventListener('click', function () { pista.scrollTo({ left: passo() * k }); }); })(i);
        box.appendChild(b);
        punti.push(b);
      }
      segna();
    }

    function segna() {
      var n = Math.min(punti.length - 1, Math.round(pista.scrollLeft / passo()));
      punti.forEach(function (b, i) { b.classList.toggle('on', i === n); });
    }

    if (pista) {
      pista.addEventListener('scroll', segna, { passive: true });
      var rifai = function () { disegnaPunti(); };
      rifai();
      window.addEventListener('resize', rifai);
      window.addEventListener('load', rifai);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(rifai);
    }

    // descrizione, scheda tecnica e utilizzo
    var schede = sez.querySelector('[data-rf-schede]');
    if (schede) {
      var bottoni = [].slice.call(schede.querySelectorAll('button'));
      bottoni.forEach(function (b) {
        b.addEventListener('click', function () {
          bottoni.forEach(function (x) {
            var on = x === b;
            x.classList.toggle('on', on);
            x.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          sez.querySelectorAll('[data-pane]').forEach(function (pn) { pn.hidden = pn.dataset.pane !== b.dataset.t; });
        });
      });
    }

    var foto = sez.querySelector('.rf-pdp__sl--flacone img');

    var seg = sez.querySelector('[data-rf-seg]');
    var prezzo = sez.querySelector('[data-rf-prezzo]');
    var litro = sez.querySelector('[data-rf-litro]');
    var litro2 = sez.querySelector('[data-rf-litro2]');
    var eti = sez.querySelector('[data-rf-eti]');
    var allitro = sez.querySelector('[data-rf-allitro]');
    var risp = sez.querySelector('[data-rf-risp]');
    var sup = sez.querySelector('[data-rf-sup]');
    var campo = sez.querySelector('[data-rf-id]');
    var add = sez.querySelector('[data-rf-add]');

    function scegli(b) {
      var voci = seg.querySelectorAll('button');
      voci.forEach(function (x) {
        x.classList.toggle('on', x === b);
        x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
      });
      if (campo) campo.value = b.dataset.rfV;
      if (prezzo) prezzo.innerHTML = b.dataset.prezzo;
      if (litro) litro.textContent = b.dataset.litro || '';
      if (litro2) litro2.textContent = b.dataset.litro || '';
      if (eti) eti.textContent = b.dataset.eti || '';
      var cornice = foto ? foto.parentNode : null;
      if (foto && b.dataset.img && cornice.dataset.rfV !== b.dataset.rfV) {
        cornice.dataset.rfV = b.dataset.rfV;
        var nuova = new Image();
        var metti = function () {
          if (cornice.dataset.rfV !== b.dataset.rfV) return;
          foto.removeAttribute('srcset');
          foto.src = b.dataset.img;
          if (b.dataset.alt) foto.alt = b.dataset.alt;
        };
        nuova.onload = function () { (nuova.decode ? nuova.decode() : Promise.resolve()).then(metti, metti); };
        nuova.onerror = metti;
        nuova.src = b.dataset.img;
        if (pista && pista.scrollLeft > 0) pista.scrollTo({ left: 0 });
      }
      if (allitro) allitro.textContent = b.dataset.allitro || '';
      if (risp) risp.textContent = 'il ' + (b.dataset.risp || '0') + '% in meno';
      if (sup) sup.hidden = !(b.dataset.risp && b.dataset.risp !== '0');
      if (add) {
        var pronto = b.dataset.pronto === '1';
        add.disabled = !pronto;
        var et = add.querySelector('.rf-pdp__add-t');
        if (et) {
          if (!add.dataset.testo) add.dataset.testo = et.innerHTML;
          if (pronto) {
            if (et.innerHTML !== add.dataset.testo) et.innerHTML = add.dataset.testo;
          } else {
            et.textContent = 'Non disponibile';
          }
        }
      }
      try {
        var u = new URL(window.location);
        u.searchParams.set('variant', b.dataset.rfV);
        window.history.replaceState({}, '', u);
      } catch (e) {}
    }

    if (seg) {
      seg.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () { scegli(b); });
      });
      var acceso = seg.querySelector('button.on') || seg.querySelector('button');
      if (acceso) scegli(acceso);
      var precarica = function () {
        seg.querySelectorAll('button[data-img]').forEach(function (b) { var im = new Image(); im.src = b.dataset.img; });
      };
      if ('requestIdleCallback' in window) requestIdleCallback(precarica); else setTimeout(precarica, 1200);
    }

  }

  /* scheda tecnica nella galleria: se le righe non ci stanno, tutto si rimpicciolisce in proporzione
     quanto basta per entrare, invece di restare tagliato in fondo */
  function adatta() {
    document.querySelectorAll('.rf-pdp__pan').forEach(function (pan) {
      pan.style.removeProperty('--rf-fit');
      var dispo = pan.clientHeight, serve = pan.scrollHeight;
      if (!dispo || serve <= dispo + 1) return;
      var k = Math.max(0.5, dispo / serve);
      pan.style.setProperty('--rf-fit', k.toFixed(3));
      // altri passaggi: spazi e margini non scalano del tutto, si stringe finché entra
      for (var i = 0; i < 4 && pan.scrollHeight > pan.clientHeight && k > 0.5; i++) {
        k = Math.max(0.5, k * pan.clientHeight / pan.scrollHeight - 0.01);
        pan.style.setProperty('--rf-fit', k.toFixed(3));
      }
    });
  }
  var attesaFit;
  function adattaPresto() { clearTimeout(attesaFit); attesaFit = setTimeout(adatta, 120); }
  window.addEventListener('resize', adattaPresto);
  window.addEventListener('load', adatta);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(adatta);

  function tutte() { document.querySelectorAll('.rf-pdp').forEach(avvia); adatta(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tutte);
  else tutte();
  document.addEventListener('shopify:section:load', tutte);
})();
